/**
 * Mixin for generating SiteNavigationElement JSON-LD schema.
 * Used on homepage and PLP pages with navigational links.
 *
 * @see https://schema.org/SiteNavigationElement
 */
import { sanitizeJsonLdStrings } from "~/utils/jsonld-sanitize";

export default {
  computed: {
    siteNavigationSchemaScript() {
      const navItems = this.navigationItems || [];

      if (navItems.length === 0) {
        return null;
      }

      const base = (this.$config?.appEndPoint || "").replace(/\/$/, "");

      const itemListElement = navItems.map((item, index) => {
        const rawUrl = item.url != null ? String(item.url) : "";
        const url = rawUrl.startsWith("http") ? rawUrl : `${base}${rawUrl}`;
        return {
          "@type": "SiteNavigationElement",
          position: index + 1,
          name: item.name,
          url,
        };
      });

      const schema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement,
      };

      const identifier = this.uid || this.$route.path || "nav";
      const hid = `jsonld-sitenav-${String(identifier)
        .replace(/[^a-z0-9_-]/gi, "-")
        .toLowerCase()}`;

      return {
        hid,
        type: "application/ld+json",
        innerHTML: JSON.stringify(sanitizeJsonLdStrings(schema)),
      };
    },
  },
};
